import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { IconVerfied } from '@prisjakt/ui/icon/verified';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { Tooltip } from '@prisjakt/ui/tooltip';
import { Direction } from '@prisjakt/ui';
import { Badge } from '@prisjakt/ui/badge';
import { useAppContext } from 'src/components/app-context';
import { ViewSize } from '../../types';

type Props = {
  className?: string;
};

export const AuthorizedDealerBadge: React.FC<Props> = ({ className }) => {
  const { offer, product, viewSize } = usePriceRowContext();
  const { t } = useAppContext();

  const content = (
    <>
      {viewSize === ViewSize.SMALL && (
        <Badge circular color="BLUE" icon={IconVerfied} />
      )}

      {viewSize >= ViewSize.MEDIUM && (
        <Badge
          color="BLUE"
          icon={IconVerfied}
          text={
            <BodySmallText weight={600} style={{ fontSize: 12 }}>
              {t('store', 'brand.recommended-retailer')}
            </BodySmallText>
          }
        />
      )}
    </>
  );

  if (!product.brand || !offer.store) {
    return content;
  }

  return (
    <Tooltip
      className={className}
      title={t('store', 'store.recommended-retailer-brand', {
        brand: product.brand.name,
        store: offer.store.name,
      })}
      placement={Direction.Left}
    >
      {content}
    </Tooltip>
  );
};
